//import components
import mainnav from '@/components/_globals/mainnav/mainnav.vue'

//import projects
import projects from '@/assets/json/projects/projects.json'

export default {
  name: 'projects',
  components: {
    mainnav
  },
  date () {
    return {
      projectData: {}
    }
  },
  created () {
    //console.log(projects)
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    getProjects () {
      return projects
    },
    hideHamburger () {
      return this.$store.state.startSite
    }
  },
  methods: {
    linkProps (url) {
      if (url.match(/^(http(s)?|ftp):\/\//)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        is: 'router-link',
        to: url
      }
    },
    renderLink (url) {
      return url.replace(/(^\w+:|^)\/\//, '')
    },
    goToProject (project) {
      this.projectData = { id: project.main.id, emitted: true }
      this.$router.push({ path: `/project` })
      this.$store.state.projectData = this.projectData
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/projects.js